import { render, staticRenderFns } from "./AcademyCreateMode.vue?vue&type=template&id=e351bdda&scoped=true&lang=pug&"
import script from "./AcademyCreateMode.vue?vue&type=script&lang=ts&"
export * from "./AcademyCreateMode.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyCreateMode.vue?vue&type=style&index=0&id=e351bdda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e351bdda",
  null
  
)

export default component.exports